export const TEXT_BOLD_CLASSES = '';